import React from "react";
import MuiRadio from "@material-ui/core/Radio";
import { makeStyles } from "@material-ui/core/styles";
import { ReactComponent as HeartIcon } from "@images/heart-icon-outline.svg";
import { ReactComponent as HeartIconFill } from "@images/heart-icon-outline-fill.svg";

const useStyles = makeStyles((theme) => ({
    root: {
        color: theme.palette.secondary.light,
    },
    checked: {
        color: theme.palette.primary.main,
    },
}));

const cardStyles = {
    position: "relative",
    left: "39%",
    marginBottom: "-14%",
};

const Radio = (props) => {
    const styles = useStyles();
    const cardVariantProps = {
        checkedIcon: <HeartIconFill />,
        icon: <HeartIcon />,
        style: cardStyles,
    };
    return (
        <MuiRadio
            classes={styles}
            checked={props.isChecked}
            color="default"
            disabled={props.isDisabled}
            disableRipple={props.disableRipple}
            id={props.componentId}
            inputProps={props.inputProps}
            inputRef={props.inputRef}
            name={props.name}
            onChange={props.onChange}
            required={props.isRequired}
            size={props.size}
            value={props.value}
            {...(props.card) && cardVariantProps}
        />
    );
};

export default Radio;